import { ApiClient } from '@webapp/core/services/ApiClient'
import { createLocalStorage } from '@webapp/core/services/LocalPersistentStorage'
import { accountRepository } from '@webapp/platform/finance'
import { OrderItemRepository } from './OrderItemRepository'

export const orderItemRepository = new OrderItemRepository({
  httpClient: ApiClient,
  accountRepository,
  persistentStorage: createLocalStorage(),
})
